// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__32oNJ","icon":"style_icon__34P5j"};